// extracted by mini-css-extract-plugin
export default {"group__title":"dSU4X","group__items":"IbJNV","group__items--half":"YJOjy","tariff":"EGVSC"};